import { TimeMap, CustomerBudgetMap, ProfitabilityData } from './types';

export function calculateProfitability(
  timeMap: Map<string, TimeMap>,
  budgetMap: Map<string, CustomerBudgetMap>,
  activeCustomers: string[]
): ProfitabilityData[] {
  // Calculate total time and budget across all customers
  const totalTime = Array.from(timeMap.values()).reduce(
    (sum, customer) => sum + Object.values(customer.years).reduce((a, b) => a + b, 0),
    0
  );

  const totalBudget = Array.from(budgetMap.values()).reduce(
    (sum, customer) => sum + (customer.total || 0),
    0
  );

  // Only process active customers
  return activeCustomers.map(customerName => {
    const customerTime = Object.values(timeMap.get(customerName)?.years || {})
      .reduce((sum, months) => sum + months, 0);

    const customerBudget = budgetMap.get(customerName)?.total || 0;

    // Calculate monthly budget
    const monthlyBudget = customerTime > 0 ? customerBudget / customerTime : 0;

    // Calculate allocations, ensuring we don't divide by zero
    const timeAllocation = totalTime > 0 ? customerTime / totalTime : 0;
    const budgetAllocation = totalBudget > 0 ? customerBudget / totalBudget : 0;

    // Calculate profitability index, avoiding division by zero
    const profitabilityIndex = timeAllocation > 0 ? budgetAllocation / timeAllocation : 0;

    return {
      customerName,
      timeAllocation,
      budgetAllocation,
      profitabilityIndex,
      totalBudget: customerBudget,
      monthlyBudget,
      color: timeMap.get(customerName)?.color
    };
  }).filter(data => {
    // Filter out any entries with invalid data
    return !isNaN(data.timeAllocation) && 
           !isNaN(data.budgetAllocation) && 
           !isNaN(data.profitabilityIndex) &&
           !isNaN(data.totalBudget) &&
           !isNaN(data.monthlyBudget);
  });
}